import React from "react";

const Termsandcondition = () => {
    return(
        <p className="text-gray-500 mt-5 text-sm text-center lg:text-start">
            By signing in to your account you agree to Campus Crow <br/>
            <span className="cursor-pointer text-primary hover:underline">Terms of Service</span> and <span className="cursor-pointer text-primary hover:underline">Privacy Policy</span>
        </p>
    )
}

export default Termsandcondition;